// extracted by mini-css-extract-plugin
export var boxItems = "_9f-1";
export var button = "_9f-5";
export var filterGroupBox = "_9f-0";
export var icon = "_9f-2";
export var iconSecondary = "_9f-4";
export var iconWrapper = "_9f-3";